export default function oztix() {
	if (typeof Object.assign != "function") {
		// Must be writable: true, enumerable: false, configurable: true
		Object.defineProperty(Object, "assign", {
			value: function assign(target, varArgs) {
				// .length of function is 2
				"use strict";
				if (target == null) {
					// TypeError if undefined or null
					throw new TypeError(
						"Cannot convert undefined or null to object"
					);
				}
				var to = Object(target);
				for (var index = 1; index < arguments.length; index++) {
					var nextSource = arguments[index];
					if (nextSource != null) {
						// Skip over if undefined or null
						for (var nextKey in nextSource) {
							// Avoid bugs when hasOwnProperty is shadowed
							if (
								Object.prototype.hasOwnProperty.call(
									nextSource,
									nextKey
								)
							) {
								to[nextKey] = nextSource[nextKey];
							}
						}
					}
				}
				return to;
			},
			writable: true,
			configurable: true,
		});
	}
	function getUrlParameter(sParam) {
		var sPageURL = decodeURIComponent(window.location.search.substring(1)),
			sURLVariables = sPageURL.split("&"),
			sParameterName,
			i;
		for (i = 0; i < sURLVariables.length; i++) {
			sParameterName = sURLVariables[i].split("=");
			if (sParameterName[0] === sParam) {
				return sParameterName[1] === undefined
					? true
					: sParameterName[1];
			}
		}
	}
	function updateQueryStringParameter(uri, key) {
		var value = getUrlParameter(key);
		if (value !== undefined) {
			var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
			var separator = uri.indexOf("?") !== -1 ? "&" : "?";
			if (uri.match(re)) {
				return uri.replace(re, "$1" + key + "=" + value + "$2");
			} else {
				return uri + separator + key + "=" + value;
			}
		}
		return uri;
	}
	function addUtmContent(uri) {
		var key = "utm_content";
		var value = "gtf_website";
		var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
		var separator = uri.indexOf("?") !== -1 ? "&" : "?";
		if (uri.match(re)) {
			return uri.replace(re, "$1" + key + "=" + value + "$2");
		} else {
			return uri + separator + key + "=" + value;
		}
	}
	function updateUtmToMatchPage(uri) {
		uri = addUtmContent(uri);
		uri = updateQueryStringParameter(uri, "utm_id");
		uri = updateQueryStringParameter(uri, "utm_adset");
		uri = updateQueryStringParameter(uri, "utm_source");
		uri = updateQueryStringParameter(uri, "utm_campaign");
		uri = updateQueryStringParameter(uri, "utm_content");
		uri = updateQueryStringParameter(uri, "utm_medium");
		uri = updateQueryStringParameter(uri, "utm_term");
		uri = updateQueryStringParameter(uri, "r");
		uri = updateQueryStringParameter(uri, "ref");
		return uri;
	}
	document.querySelectorAll("a").forEach(function (el) {
		let url = el.getAttribute("href");
		let newUrl = updateUtmToMatchPage(url);
		el.setAttribute("href", newUrl);
	});
}
